import { render, staticRenderFns } from "./countDetail.vue?vue&type=template&id=a0198202&scoped=true&"
import script from "./countDetail.vue?vue&type=script&lang=js&"
export * from "./countDetail.vue?vue&type=script&lang=js&"
import style0 from "./countDetail.vue?vue&type=style&index=0&id=a0198202&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0198202",
  null
  
)

export default component.exports